module.exports = __webpack_public_path__ + "static/img/rongyu1.c138184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rongyu1.jpg
// module id = XA6V
// module chunks = 1